import React from 'react'
import viewbannerpic from "../../../assets/images/viewbackground.png"
import colimg from "../../../assets/images/colimg.png"
import "./viewbanner.scss"
const Viewbanner = () => {
  return (
    <div> <div className="viewback">
    <img src={viewbannerpic} alt="" />
   </div>
    <div className='viewdetail'>
      

      <div className="viewtopcont">
        <div className="tophead">
            <h2>Our Data Journey</h2>
        </div>
        <div className="viewcard">
            <div className="cardhead">
                <h2>
                Data Empowerment: A Journey Through Integration and Analysis
                </h2>
                <p>
                Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Vivamus et venenatis mauris. Nunc dapibus 
                maximus nisi, at vulputate libero scelerisque eu. Curabitur venenatis at nunc at lobortis. Aenean luctus justo vitae. 
                </p>
            </div>
            <div className="cardbtm">
                <div className="col1">
                  <div className="colright">
                    <h3>
                    Building a Unified Foundation
                    </h3>
                    <p>
                    Curabitur aliquet ex bibendum mi tempor lobortis. Curabitur eget massa quis velit vulputate efficitur. Donec aliquam lacinia urna a viverra. Pellentesque in porta magna. Curabitur id fringilla sapien, a vestibulum libero. Sed eget fermentum eros.
                    </p>
                  </div>
                  <div className="colleft">
                    <img src={colimg} alt="" />
                  </div>
                </div>
                <div className="col1">
                  <div className="colright">
                    <h3>
                    Building a Unified Foundation
                    </h3>
                    <p>
                    Curabitur aliquet ex bibendum mi tempor lobortis. Curabitur eget massa quis velit vulputate efficitur. Donec aliquam lacinia urna a viverra. Pellentesque in porta magna. Curabitur id fringilla sapien, a vestibulum libero. Sed eget fermentum eros.
                    </p>
                  </div>
                  <div className="colleft">
                    <img src={colimg} alt="" />
                  </div>
                </div>
                <div className="col1">
                  <div className="colright">
                    <h3>
                    Building a Unified Foundation
                    </h3>
                    <p>
                    Curabitur aliquet ex bibendum mi tempor lobortis. Curabitur eget massa quis velit vulputate efficitur. Donec aliquam lacinia urna a viverra. Pellentesque in porta magna. Curabitur id fringilla sapien, a vestibulum libero. Sed eget fermentum eros.
                    </p>
                  </div>
                  {/* <div className="colleft">
                    <img src={colimg} alt="" />
                  </div> */}
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Viewbanner
